/** Closed retained components are server values, separately per currency. */
import { Alert, Box } from '@mui/material';
import { useCopy } from '@/hooks/useCopy';
import { formatMoney } from '@/format';
import type { RetainedMargin } from '@/api/tmm/types';

export function RetainedMarginStrip({ rows, locale }: { rows: RetainedMargin[]; locale: string }) {
  const { t } = useCopy();
  if (rows.length === 0) return null;
  const title = t('dashboard.retainedMargin.title', 'Retained margin');
  return (
    <Alert severity="info" sx={{ mb: 3 }}>
      <Box component="span" sx={{ fontWeight: 600, mr: 1 }}>
        {title}
      </Box>
      <Box
        component="ul"
        aria-label={title}
        sx={{ display: 'inline', m: 0, p: 0, listStyle: 'none' }}
      >
        {rows.map((row, index) => (
          <Box
            component="li"
            key={row.currency}
            sx={{ display: 'inline', fontVariantNumeric: 'tabular-nums' }}
          >
            {index > 0 ? '; ' : null}
            {formatMoney(row.netMinor, row.currency, locale)}
          </Box>
        ))}
      </Box>
      {rows.some((row) => row.netMinor < 0) ? (
        <Box component="span" sx={{ ml: 1 }}>
          {t('dashboard.retainedMargin.absorbed', 'Absorbed by the platform.')}
        </Box>
      ) : null}
    </Alert>
  );
}
